import z from "zod";

const forecastItemSchema = z.object({
	timestep: z.string(),
	ww: z.coerce.number(),
	temperature_2m: z.number(),
	precipitation_accumulation_3h: z.number(),
	wind_direction_10m: z.number(),
	wind_speed_10m: z.number(),
});

export const worldForecastSchema = z.array(forecastItemSchema);

export const worldForecastArraySchema = z.object({
	data: worldForecastSchema,
});

export type WorldForecastSchema = z.infer<typeof worldForecastSchema>;
export type WorldForecastItem = WorldForecastSchema[number];